import { observer } from 'mobx-react';
import React from 'react';
import { IonList, IonItemDivider } from '@ionic/react';
import { Trans as T } from 'react-i18next';
import {
  locationOutline,
  gridOutline,
  squareOutline,
  checkboxOutline,
  mapOutline,
} from 'ionicons/icons';
import { prettyPrintGridRef, Main, MenuAttrItem } from '@apps';
import InfoBackgroundMessage from 'Components/InfoBackgroundMessage';
import PropTypes from 'prop-types';
import 'common/images/transect.svg';
import './styles.scss';

@observer
class Component extends React.Component {
  static propTypes = {
    sample: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool,
  };

  getPointsList = () => {
    const { sample, match } = this.props;
    if (!sample.samples.length) {
      return (
        <InfoBackgroundMessage>
          To see quadrats please select your site and quadrat group first.
        </InfoBackgroundMessage>
      );
    }

    const getPointItem = subSample => {
      const { cid } = subSample;

      const { gridref } = subSample.attrs.location;
      const prettyGridRef = gridref ? prettyPrintGridRef(gridref) : '';

      const locationLabel = subSample.getPrettyName();
      const { completed } = subSample.metadata;
      const icon = completed ? checkboxOutline : squareOutline;

      return (
        <MenuAttrItem
          key={cid}
          routerLink={`${match.url}/${cid}`}
          value={prettyGridRef}
          icon={icon}
          label={locationLabel}
          className={`survey-point-item ${completed && 'completed'}`}
          skipTranslation
        />
      );
    };

    const pointsList = sample.samples.map(getPointItem);

    return (
      <>
        <IonItemDivider>
          <T>Quadrats</T>
        </IonItemDivider>
        {pointsList}
      </>
    );
  };

  render() {
    const { sample, isDisabled, match } = this.props;
    const { location = {} } = sample.attrs;
    const site = sample.metadata.site || {};
    const hasLocation = !!location.name;

    return (
      <Main>
        <IonList lines="full">
          <MenuAttrItem
            routerLink={`${match.url}/sites`}
            disabled={isDisabled}
            value={site.name}
            label="Site"
            icon={locationOutline}
            wrapText
            skipValueTranslation
          />

          <MenuAttrItem
            routerLink={`${match.url}/list`}
            disabled={isDisabled || !site.name}
            value={location.name}
            label="Group"
            icon={gridOutline}
            wrapText
            skipValueTranslation
          />

          <MenuAttrItem
            routerLink={`${match.url}/map`}
            disabled={isDisabled || !site.name || !hasLocation}
            label="Map"
            icon={mapOutline}
            wrapText
          />

          {this.getPointsList()}
        </IonList>
      </Main>
    );
  }
}

export default Component;
